import { LanguageApiResponse } from "@resources/Language.apiResponse";

export class LanguageViewModel {
  id: string | null;
  shortCode: string | null;
  i18nexusId: string | null;
  name: string | null;
  zohoLanguage: string | null;
  zohoLayoutId: string | null;

  constructor(apiResponse: LanguageApiResponse) {
    this.id = apiResponse.id;
    this.shortCode = apiResponse.shortCode;
    this.i18nexusId = apiResponse.i18nexusId;
    this.name = apiResponse.name;
    this.zohoLanguage = apiResponse.zohoLanguage;
    this.zohoLayoutId = apiResponse.zohoLayoutId;
  }
}
